import translations from './translations'

const DEFAULT_LANGUAGE = "en"

const langs = {
  'it-IT': 'it',
  'en-US': 'en'
}


const UrlUtils = {
  // Estrae la lingua dal path: /it/artisti -> 'it'
  getLanguageFromPath: (path = window.location.pathname) => {
    const segments = path.split('/').filter(s => s);
    const firstSegment = segments[0];
    if(Object.keys(translations).includes(firstSegment)) {
      return firstSegment ;
    } else if (navigator.language && langs[navigator.language]) {
      return langs[navigator.language];
    } else {
      return DEFAULT_LANGUAGE;
    }
  },
  
  // Estrae la sezione dal path: /it/artisti -> 'artisti'
  getSectionFromPath: (path = window.location.pathname) => {
    const segments = path.split('/').filter(s => s);
    return segments.length > 1 ? segments[1] : '';
  },

  getSectionWithParamsFromPath: (path = window.location.pathname) => {
    const segments = path.split('/').filter(s => s);
    return segments.length > 1 ? segments.splice(1).join("/") : '';
  },

  isHome: (path = window.location.pathname) => {
    const section = UrlUtils.getSectionFromPath(path);
    return section.toLowerCase() === "home" || section === ''; 
  },
  
  // Costruisce URL localizzato: ('en', 'artists') -> '/en/artists'
  buildLocalizedUrl: (language, section = '') => {
    const slug = section ? translations[language]?.slugs?.[section] || section : '';
    return slug ? `/${language}/${slug}` : `/${language}`;
  },
  
  // Ottiene la chiave della sezione dal slug: 'chi-siamo' -> 'about'
  getSectionKeyFromSlug: (slug, language) => {
    const slugs = translations[language]?.slugs || {};
    return Object.keys(slugs).find(key => slugs[key] === slug) || 'home';
  }
};

export { UrlUtils }